import React from 'react';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';

import randomstring from 'uuid/v4';

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import Close from '@material-ui/icons/Close';

class Filter extends React.Component {
    state = {
        from: this.props.from,
        to: this.props.to,
        local: this.props.local,
    };

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleRemoveDate = (nombre) => (event) => {
        this.setState({ [nombre]: '' });
    };

    handleClose = (from, to, local) => (event) => {
        this.props.handleClose(from, to, local);
    };

    render() {
        const { from, to, local } = this.state;
        const { intl, info } = this.props;
        const nodes = info.security.locals.reduce((arr, c) => {
            if (info.security.localPermits[c.id] && info.security.localPermits[c.id].length > 0) {
                arr.push(c);
            }
            return arr;
        }, []);

        return (
            <Dialog
                open={true}
                onClose={this.handleClose()}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent className={'padding_borders'}>
                    <div className="flex_full_row margin_top_32 align_center">
                        <TextField
                            fullWidth
                            name={'from'}
                            id={'from-date'}
                            label={intl.formatMessage({ id: 'form_field_add_date_init_label' })}
                            type="date"
                            value={from ? from : ''}
                            onChange={this.handleChange}
                            InputLabelProps={{ shrink: true }}
                        />
                        <Close
                            className="c_lipstick hand"
                            onClick={this.handleRemoveDate('from')}
                        />
                    </div>
                    <div className="flex_full_row margin_top_32 align_center">
                        <TextField
                            fullWidth
                            name={'to'}
                            id={'to-date'}
                            label={intl.formatMessage({ id: 'form_field_add_date_end_label' })}
                            type="date"
                            value={to ? to : ''}
                            onChange={this.handleChange}
                            InputLabelProps={{ shrink: true }}
                        />
                        <Close
                            className="c_lipstick hand"
                            onClick={this.handleRemoveDate('to')}
                        />
                    </div>
                    <div className="flex_full_row margin_top_32 align_center">
                        <FormControl className={'flex_full width100 barlow_italic c_slate'}>
                            <InputLabel htmlFor="age-native-simple">
                                {intl.formatMessage({ id: 'type_label_local' })}
                            </InputLabel>
                            <Select
                                native
                                value={local}
                                onChange={this.handleChange}
                                inputProps={{ name: 'local', id: 'local-id' }}
                            >
                                <option key={randomstring()} value={undefined} />
                                {nodes &&
                                    nodes.map((cat) => {
                                        return (
                                            <option key={randomstring()} value={cat.id}>
                                                {cat.name}
                                            </option>
                                        );
                                    })}
                            </Select>
                        </FormControl>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose()} color="primary">
                        <FormattedMessage id="remove" />
                    </Button>
                    <Button onClick={this.handleClose(from, to, local)} color="primary" autoFocus>
                        <FormattedMessage id="accept" />
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

Filter.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(Filter);



// WEBPACK FOOTER //
// ./src/components/complex/alerts/FilterMenu.js